import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "classNames"];
import { cx } from "../../lib/cx.js";
export function createAutocompletePanelComponent(_ref) {
  var createElement = _ref.createElement;
  return function AutocompletePanel(userProps) {
    var children = userProps.children,
      _userProps$classNames = userProps.classNames,
      classNames = _userProps$classNames === void 0 ? {} : _userProps$classNames,
      props = _objectWithoutProperties(userProps, _excluded);
    return createElement("div", _extends({}, props, {
      className: cx('ais-AutocompletePanel', classNames.root, props.className)
    }), createElement("div", {
      className: cx('ais-AutocompletePanelLayout', classNames.layout)
    }, children));
  };
}